import React from "react";
import Navbar from "../components/Navbar";
import MovieList from "../components/MovieList";
import { rawHtml } from "../utils";
import Footer from "../components/Footer";
import { pageFilter, getArtistCookie } from "../data/page_data";
import FlickitySlider from "../components/FlickitySlider";
import CssLoader from "../components/CssLoader";
import ShareButton from "../components/ShareButton";
import { Button } from "reactstrap";
import * as ReactGA from "react-ga";
import FloatingButton from "../components/FloatingButton";

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.pageData = pageFilter(this.props.artist, "../");
    this.state = {};
  }

  toggleShare = () => {
    this.setState({ share: !this.state.share });
  };

  componentDidMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  render() {
    return (
      <>
        <CssLoader css={this.pageData.artist.css} />
        <Navbar data={this.pageData} title="PROFILE" />

        <div className="content profile">
          {this.pageData.artist.profile.image && (
            <div className="profile-img">
              <img src={this.pageData.artist.profile.image} />
            </div>
          )}
          <div className="container">
            {this.pageData.artist.floating_url && (
                <FloatingButton url={this.pageData.artist.floating_url} />
            )}
            <div className="profile-text">
              <h3>Biografi</h3>
              {(this.pageData.artist.profile.description || []).map((item, index) => {
                return <p key={index} dangerouslySetInnerHTML={{ __html: item }} />;
              })}
            </div>
            <hr />
            <div className="profile-detail">
              <h3>Biodata</h3>
              <table>
                <tbody>
                  {(this.pageData.artist.profile.bio || []).map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.label}</td>
                        <td>:</td>
                        <td>{item.val}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <hr />
            <div className="profile-text pt-0">
              <h3>Karir</h3>
              {(this.pageData.artist.profile.career || []).map((item, index) => {
                return <p key={index} dangerouslySetInnerHTML={{ __html: item }} />;
              })}
            </div>

            {!this.pageData.artist.profile.music ? (
              <></>
            ) : (
              <>
                <hr />
                <div className="music-list">
                  <h3>Musics</h3>
                  <FlickitySlider
                    options={{
                      freeScroll: true,
                      contain: true,
                      prevNextButtons: false,
                      pageDots: false,
                    }}
                  >
                    {this.pageData.artist.profile.music.map((item, index) => {
                      return (
                        <div className="carousel-cell" key={index}>
                          <a href={item.url}>
                            <div className="music-list-wrapper">
                              <div className="img-square">
                                <img src={item.image} />
                              </div>
                              <div className="music-title">{item.title}</div>
                              <div className="music-bottom">
                                <span>
                                  {item.subtitle}
                                  <em> {item.subtitle_em}</em>
                                </span>
                                <span>
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    viewBox="0 0 60 18"
                                  >
                                    <path
                                      className="a"
                                      d="M9.35.15A8.85,8.85,0,1,0,18.2,9,8.85,8.85,0,0,0,9.35.15Zm4.06,12.76a.56.56,0,0,1-.76.19,10.21,10.21,0,0,0-7.78-.86.55.55,0,1,1-.24-1.07c3.37-.77,6.26-.44,8.59,1A.56.56,0,0,1,13.41,12.91Zm1.08-2.41a.69.69,0,0,1-1,.23,11.6,11.6,0,0,0-8.82-1,.69.69,0,1,1-.4-1.32,12.92,12.92,0,0,1,9.94,1.17A.69.69,0,0,1,14.49,10.5ZM14.58,8C11.73,6.3,7,6.14,4.3,7a.83.83,0,0,1-.48-1.58C7,4.44,12.14,4.62,15.43,6.57A.83.83,0,1,1,14.58,8Z"
                                    />
                                    <path
                                      className="a"
                                      d="M24.57,8.32C23,8,22.77,7.7,22.77,7.16s.48-.85,1.19-.85a3.46,3.46,0,0,1,2.09.8.09.09,0,0,0,.07,0,.08.08,0,0,0,.07,0l.75-1a.09.09,0,0,0,0-.13,4.48,4.48,0,0,0-2.94-1,2.51,2.51,0,0,0-2.8,2.41c0,1.51,1,2.05,2.71,2.47,1.46.33,1.71.62,1.71,1.12s-.5.91-1.3.91a3.48,3.48,0,0,1-2.43-1,.11.11,0,0,0-.08,0,.07.07,0,0,0-.06,0l-.84,1a.1.1,0,0,0,0,.14,5,5,0,0,0,3.37,1.29c1.77,0,2.92-1,2.92-2.48C27.19,9.47,26.43,8.77,24.57,8.32Z"
                                    />
                                    <path
                                      className="a"
                                      d="M31.21,6.81a2.37,2.37,0,0,0-1.92.93V7a.09.09,0,0,0-.1-.1H27.82a.1.1,0,0,0-.1.1v7.77a.1.1,0,0,0,.1.1h1.37a.09.09,0,0,0,.1-.1V12.36a2.46,2.46,0,0,0,1.92.87A3,3,0,0,0,34.09,10,3,3,0,0,0,31.21,6.81ZM32.5,10a1.65,1.65,0,0,1-1.6,1.82A1.69,1.69,0,0,1,29.26,10,1.69,1.69,0,0,1,30.9,8.2,1.66,1.66,0,0,1,32.5,10Z"
                                    />
                                    <path
                                      className="a"
                                      d="M37.81,6.81A3.22,3.22,0,1,0,41.08,10,3.23,3.23,0,0,0,37.81,6.81Zm0,5A1.73,1.73,0,0,1,36.09,10a1.7,1.7,0,0,1,1.7-1.81A1.75,1.75,0,0,1,39.52,10,1.7,1.7,0,0,1,37.81,11.85Z"
                                    />
                                    <path
                                      className="a"
                                      d="M45,6.94h-1.5V5.4a.1.1,0,0,0-.1-.1H42.05a.09.09,0,0,0-.1.1V6.94h-.66a.1.1,0,0,0-.1.1V8.21a.1.1,0,0,0,.1.1H42v3a1.63,1.63,0,0,0,1.82,1.86,2.48,2.48,0,0,0,1.28-.32.11.11,0,0,0,.05-.09V11.68a.09.09,0,0,0-.05-.08.12.12,0,0,0-.1,0,1.72,1.72,0,0,1-.8.2c-.44,0-.63-.2-.63-.65V8.31H45a.09.09,0,0,0,.1-.1V7A.09.09,0,0,0,45,6.94Z"
                                    />
                                    <path
                                      className="a"
                                      d="M50.27,6.94V6.75c0-.55.21-.8.69-.8a2.5,2.5,0,0,1,.77.14.1.1,0,0,0,.09,0,.12.12,0,0,0,0-.08V4.84a.1.1,0,0,0-.07-.09,3.75,3.75,0,0,0-1.14-.17c-1.26,0-1.93.72-1.93,2.06v.29h-.66A.11.11,0,0,0,48,7V8.21a.1.1,0,0,0,.1.1h.66V13a.1.1,0,0,0,.1.1h1.37a.1.1,0,0,0,.1-.1V8.31h1.28l2,4.69c-.22.5-.44.59-.74.59a1.58,1.58,0,0,1-.75-.21.11.11,0,0,0-.08,0,.09.09,0,0,0-.06.06l-.46,1a.09.09,0,0,0,0,.13,2.8,2.8,0,0,0,1.46.38c1,0,1.57-.47,2.06-1.74l2.37-6.13a.07.07,0,0,0,0-.09.09.09,0,0,0-.08,0H55.85a.12.12,0,0,0-.1.07l-1.46,4.17L52.7,7a.12.12,0,0,0-.1-.07Z"
                                    />
                                    <rect
                                      className="a"
                                      x="45.76"
                                      y="6.94"
                                      width="1.57"
                                      height="6.17"
                                      rx="0.1"
                                    />
                                    <path
                                      className="a"
                                      d="M46.55,4.22a1,1,0,1,0,1,1A1,1,0,0,0,46.55,4.22Z"
                                    />
                                    <path
                                      className="a"
                                      d="M58.53,8.86a1,1,0,1,1,1-1A1,1,0,0,1,58.53,8.86Zm0-1.84a.87.87,0,1,0,.86.87A.86.86,0,0,0,58.54,7Zm.21,1,.27.38h-.23L58.55,8h-.21v.35h-.19v-1h.45c.23,0,.39.12.39.32A.31.31,0,0,1,58.75,8Zm-.16-.46h-.25v.32h.25c.12,0,.2-.06.2-.16S58.71,7.53,58.59,7.53Z"
                                    />
                                  </svg>
                                </span>
                              </div>
                            </div>
                          </a>
                        </div>
                      );
                    })}
                    <div className="div-last-slider"></div>
                  </FlickitySlider>
                </div>
              </>
            )}

            {!this.pageData.artist.profile.movies ? (
              <></>
            ) : (
              <>
                <hr />
                <div className="movie-list">
                  <h3>Movies</h3>

                  <FlickitySlider
                    options={{
                      freeScroll: true,
                      contain: true,
                      prevNextButtons: false,
                      pageDots: false,
                    }}
                  >
                    {this.pageData.artist.profile.movies.map((item, index) => {
                      return (
                        <div className="carousel-cell" key={index}>
                          <div className="movie-list-wrapper">
                            <div className="movie-list-item">
                              <img src={item.image} />
                            </div>
                            <div className="movies-title">{item.title}</div>
                            <div className="movies-year">
                              {item.subtitle}
                              <em> {item.subtitle_em}</em>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                    <div className="div-last-slider"></div>
                  </FlickitySlider>
                </div>
              </>
            )}

            {!this.pageData.artist.profile.achievement ? (
              <></>
            ) : (
              <>
                <hr />
                <div className="achievement-list">
                  <h3>Achievements</h3>
                  <ul>
                    {this.pageData.artist.profile.achievement.map(
                      (item, index) => {
                        return <li key={index}>{item}</li>;
                      }
                    )}
                  </ul>
                </div>
              </>
            )}

            <Button
              onClick={() => this.setState({ share: true })}
              color="none"
              className="more btn-share"
            >
              <span>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 46 46">
                  <g transform="translate(-237.041 -1076)">
                    <g className="a" transform="translate(247.707 1085.636)">
                      <path
                        d="M-492.652,97.374h0a2.048,2.048,0,0,0-1.769.24l-9.147,6.137-4.452,2.987h0l-6.755,4.533a2.418,2.418,0,0,0-1.06,2.212,2.417,2.417,0,0,0,1.216,1.9l4.183,1.852v-.023a1.188,1.188,0,0,0,1.027-.306l10.475-9.958a.278.278,0,0,1,.287-.057.284.284,0,0,1,.193.27.27.27,0,0,1-.076.188l-9.362,10.184a.6.6,0,0,0-.156.406v5.134a1.777,1.777,0,0,0,.892,1.574,1.731,1.731,0,0,0,1.317.153,1.731,1.731,0,0,0,1.039-.823l1.87-3.369,5.053,2.25a2.407,2.407,0,0,0,2.136-.089,2.407,2.407,0,0,0,1.222-1.754l3.239-21.39a1.931,1.931,0,0,0,.023-.308A2.039,2.039,0,0,0-492.652,97.374Zm-13.2,26.015a.535.535,0,0,1-.311.249.523.523,0,0,1-.42-.048.6.6,0,0,1-.268-.524v-4.21l2.819,1.256Zm13.384-23.958h0l-3.239,21.4a1.209,1.209,0,0,1-.62.885,1.192,1.192,0,0,1-1.062.043l-9.055-4.034,8.795-9.565a1.484,1.484,0,0,0-.049-2.062,1.484,1.484,0,0,0-2.062-.022l-10.474,9.96-3.692-1.648a1.219,1.219,0,0,1-.713-1.008,1.219,1.219,0,0,1,.533-1.113l20.354-13.656a.836.836,0,0,1,.859-.038.835.835,0,0,1,.438.74A.67.67,0,0,1-492.467,99.431Z"
                        transform="translate(515.844 -97.272)"
                        strokeWidth="0.5"
                      />
                    </g>
                  </g>
                </svg>
              </span>
              <span>Share</span>
            </Button>
          </div>
        </div>
        <ShareButton
          view={this.state.share}
          shareUrl={`http://funseleb.com/w/${encodeURIComponent(
            this.pageData.artist.path
          )}/profile`}
          title={`Fun Seleb ${encodeURIComponent(this.pageData.artist.name)}`}
          toggle={this.toggleShare}
        />

        <Footer />
      </>
    );
  }
}

export default ProfilePage;
